import _ from "underscore";
import templateUrl from 'emun.salesrep/salesrep-sales-vendor.htm';
import productSalesPopup from "emun.salesrep/product-sales-popup";
import salesrepConfig from 'emun.salesrep/salesrep.config';
import labels from "emun.order/_labels";
import basicController from 'servicestack/basic.controller.properties';

class SalesRepSalesVendorController {
  constructor($window, $rootScope, createAutoQuery, utils) {
    basicController(this);
    let $ctrl = this;
    $ctrl.utils = utils;
    //        $ctrl.mode = "list";
    if (!$ctrl.mode) { $ctrl.mode = 'list'; }
    $ctrl.labels = labels;
    $ctrl.total = 0;
    $ctrl.colors = salesrepConfig.chartColors;
    $ctrl.chartOptions = {
      maintainAspectRatio: false,
      legend: {
        display: true
      },
      tooltips: {
        enabled: true,
        callbacks: {
          label: function (tooltipItem, data) {
            var label = data.labels[tooltipItem.index];
            let datasetLabel = data.datasets[tooltipItem.datasetIndex].data[tooltipItem.index];
            return label + ": $" + datasetLabel.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",") + "  (" + Math.round(((datasetLabel / $ctrl.total) * 100)) + '%)';
          }
        }
      },
    }
    var context = $ctrl.context || 'rep';

    var filterType = "SalesRepID";
    var repFilter = "";
    if (context !== 'executive') {
      if (context === 'manager') {
        filterType = 'ManagerId';
      }
      repFilter = "&" + filterType + "=" + $ctrl.rep.id;
    }
    if ($ctrl.insideSales) {
      if ($ctrl.insideSales === 'true') {
        repFilter = repFilter + '&IsInsideSales=true';
      }
    }

    var url = 'QuerySalesYOYTotals.json?Sum=TotalSalesMonthToDate,TotalSalesQuarterToDate,TotalSalesYearToDate,TotalSalesMonthToDateLastYear,TotalSalesQuarterToDateLastYear,TotalSalesYearToDateLastYear&GroupBy=VendorName&OrderBy=VendorName' + repFilter;

    $ctrl.salesQuery = createAutoQuery({
      url: url,
      autoLoad: false,
      onLoaded: function (args) {
        $ctrl.chartLabels = [];
        $ctrl.chartData = [];
        args.results.forEach(function (sales) {
          $ctrl.vendors.results.forEach(function (v) {
            if (sales.vendorName === v.label) {
              v.ytdTotal = sales.sumTotalSalesYearToDate;
              v.lastytdTotal = sales.sumTotalSalesYearToDateLastYear;
              v.mtdTotal = sales.sumTotalSalesMonthToDate;
              v.lastmtdTotal = sales.sumTotalSalesMonthToDateLastYear;
              $ctrl.chartLabels.push(v.label);
              $ctrl.chartData.push(Math.round(v.ytdTotal));
              $ctrl.total += v.ytdTotal;
              v.diff = v.ytdTotal - v.lastytdTotal;
              var percent = Math.round((v.ytdTotal / v.lastytdTotal) * 100);
              if (v.lastytdTotal === 0 && v.ytdTotal > 0) percent = 100;
              if (percent < 100) {
                v.percent = 100 - percent;
                v.trend = 'down';
              } else if (percent > 100) {
                v.percent = percent - 100;
                v.trend = 'up';
              } else {
                v.percent = 100;
                v.trend = 'neutral';
              }
            }
          });
        });
      }
    });
    $ctrl.isBusy = true;
    $ctrl.vendors = createAutoQuery({
      url: 'QueryVendors.json?Active=1',
      orderBy: 'Label',
      pageSize: 1000,
      autoLoad: true,
      onLoaded: function (vendors) {
        vendors.results.forEach(function (obj) {
          obj.ytdTotal = 0;
          obj.lastytdTotal = 0;
          obj.diff = 0;
          obj.percent = 0;
        });
        $ctrl.salesQuery.load(true);
      }
    });
  }
  downloadData() {
    let $ctrl = this;
    var itemsFormatted = [];

    var headers = {
      name: $ctrl.$labels.vendor || 'Vendor',
      LYTD: "YTD",
      YTD: "LYTD",
      Diff: "Diff",
      Percent: "Percent"
    };

    // format the data
    $ctrl.vendors.results.forEach((item) => {
      itemsFormatted.push({
        name: item.label.replace(/,/g, ''), // remove commas to avoid errors,
        YTD: item.ytdTotal,
        LYTD: item.lastytdTotal,
        Diff: item.diff,
        Percent: item.percent
      });
    });

    var fileTitle = 'salesrep-sales-vendor';
    $ctrl.utils.exportCSVFile(headers, _.sortBy(itemsFormatted, 'YTD').reverse(), fileTitle);
  }
}

let SalesRepSalesVendor = {
  bindings: {
    rep: '<',
    repGroup: '@',
    context: '@',
    insideSales: '@'
  },
  controller: SalesRepSalesVendorController,
  templateUrl($element, $attrs) {
    return $attrs.templateUrl || templateUrl
  }
}

export default SalesRepSalesVendor